"use client";
import SubscribeButton from "@/app/[locale]/(user-page)/report/[slug]/components/button/SubscribeButton";
import { APP_ROUTES } from "@/constants/routes";
import { REPORT_TYPE } from "@/models/report";
import { Box, Typography } from "@mui/material";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";

interface ReviewNoticeProps {
  isLogin?: boolean;
  reportType?: number;
  isPaymentEd?: boolean;
  slug?: string;
  isFullscreen?: boolean;
  isShare?: boolean;
  shouldShowReviewNotice?: () => boolean;
  isMobile?: boolean;
  locale?: string;
}

function ReviewNotice({
  isMobile,
  isLogin = false,
  reportType = REPORT_TYPE.FREE,
  isPaymentEd = false,
  slug,
  isFullscreen,
  isShare,
  shouldShowReviewNotice,
  locale,
}: ReviewNoticeProps) {
  const router = useRouter();

  const t = useTranslations("messages");
  const handleSubscribeClick = () => {
    // Handle subscription logic here
    router.push(APP_ROUTES(locale as any).PRICING.to);
  };
  // Hàm để lấy tiêu đề thông báo dựa trên loại báo cáo
  const getNoticeTitle = () => {
    if (reportType === REPORT_TYPE.FREE) {
      return t("report_subscribe_free_notice_title");
    } else if (
      reportType === REPORT_TYPE.PREMIUM ||
      reportType === REPORT_TYPE.STANDARD
    ) {
      return isLogin
        ? t("report_subscribe_premium_login_notice_title")
        : t("report_subscribe_premium_notice_title");
    }
    return t("report_subscribe_notice_title");
  };

  const getNoticeDescription = () => {
    if (reportType === REPORT_TYPE.FREE) {
      return t("report_subscribe_free_notice_description");
    } else if (
      reportType === REPORT_TYPE.PREMIUM ||
      reportType === REPORT_TYPE.STANDARD
    ) {
      return isLogin
        ? t("report_subscribe_premium_login_notice_description")
        : t("report_subscribe_premium_notice_description");
    }
    return t("report_subscribe_notice_description");
  };

  return (
    !isFullscreen &&
    !isShare &&
    shouldShowReviewNotice?.() && (
      <Box
        className={`w-full p-[20px] sm:p-[24px]  gap-[10px] flex-col border border-radius-[8px] bg-gray_2 absolute bottom-0 left-0 right-0 z-[11] overflow-y-auto mr-[51px] !hide-scrollbar`}
      >
        <Box className="w-full p-[20px] sm:p-[24px]  gap-[10px] flex-col border border-radius-[8px] bg-gray_5 h-auto min-h-[186px] max-w-full break-words">
          {/* Tiêu đề */}
          <Typography
            variant="h6"
            className="!mb-[10px] !text-ciBlue_900 !font-[Montserrat,sans-serif] !font-[600] !text-[22px] sm:!text-[24px] !leading-[24px] !tracking-[0px] whitespace-normal break-words text-left max-w-full"
          >
            {getNoticeTitle()}
          </Typography>

          {/* Mô tả */}
          <Typography
            variant="body1"
            className="!text-eerieBlack !font-[Montserrat,sans-serif] !font-[500] !text-[14px] sm:!text-[16px] !leading-[24px] !tracking-[0px] whitespace-normal break-words text-left max-w-full"
          >
            {getNoticeDescription()}
          </Typography>
          <Box className="flex my-[16px]"></Box>

          {/* Sử dụng component SubscribeButton */}
          <SubscribeButton onClick={handleSubscribeClick} />
        </Box>
      </Box>
    )
  );
}

export default ReviewNotice;
